<template>
  <b-modal
    ref="modal"
    :visible="visible"
    title="Forzar sincronización"
    @hide="handleModalHide"
    no-close-on-backdrop
    :no-close-on-esc="loading"
  >
    <b-nav tabs class="mb-3">
      <b-nav-item active>Cobros</b-nav-item>
    </b-nav>

    <b-form-group label="Desde:" label-for="fs-from-date">
      <b-form-datepicker
        id="fs-from-date"
        v-model="from"
        :date-format-options="dateFormatOptions"
        :max="to"
        :hide-header="true"
        :label-help="null"
        start-weekday="1"
        placeholder="Desde"
        :disabled="!!bcId"
      />
    </b-form-group>

    <b-form-group label="Hasta:" label-for="fs-to-date">
      <b-form-datepicker
        id="fs-to-date"
        v-model="to"
        :date-format-options="dateFormatOptions"
        :min="from"
        :hide-header="true"
        :label-help="null"
        start-weekday="1"
        placeholder="Hasta"
        :disabled="!!bcId"
      />
    </b-form-group>

    <b-form-group :label="bcIdLabel + ':'" label-for="fs-bc-id">
      <b-form-input
        id="fs-bc-id"
        v-model="bcId"
        placeholder="Vacío"
        trim
      />
      <small class="text-muted">
        Si se introduce un número de documento, las fechas serán ignoradas.
      </small>
    </b-form-group>

    <template #modal-footer>
      <div class="w-100 d-flex justify-content-center">
        <button
          type="button"
          class="btn btn-primary d-flex align-items-center justify-content-center"
          style="min-width: 140px;"
          :disabled="isSyncDisabled"
          @click="handleSync"
        >
          <b-spinner small class="mr-2" v-if="loading" />
          {{ loading ? 'Sincronizando...' : 'Sincronizar' }}
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ForceSyncSingleBCModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    endpoint: {
      type: String,
      required: true,
    },
    bcIdLabel: {
      type: String,
      default: 'Nº de documento',
    },
  },
  data() {
    return {
      from: this.getYesterday(),
      to: this.getYesterday(),
      bcId: '',
      loading: false,
      dateFormatOptions: {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      },
    }
  },
  computed: {
    isSyncDisabled() {
      if (this.loading) return true
      return !this.bcId && (!this.from || !this.to)
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.from = this.getYesterday()
        this.to = this.getYesterday()
        this.bcId = ''
      }
    },
  },
  methods: {
    getYesterday() {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      return date.toISOString().slice(0, 10)
    },
    async handleSync() {
      const body = this.bcId
        ? { bc_id: this.bcId }
        : { from: this.from, to: this.to }

      this.loading = true
      try {
        await Vue.prototype.$http.post(this.endpoint, body)
        this.$toast.success('Sincronización iniciada correctamente')
        this.$emit('sync-success')
        this.closeModal()
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'Error al iniciar la sincronización. Por favor inténtelo de nuevo.'
        this.$toast.error(errorMessage)
      } finally {
        this.loading = false
      }
    },
    closeModal() {
      this.$refs.modal.hide()
    },
    handleModalHide() {
      if (!this.loading) {
        this.$emit('close')
      }
    },
  },
}
</script>
